import DashboardLayout from 'src/components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from 'src/components/GeneralViews/NotFoundPage.vue'
//auth pages
import Login from 'src/components/Auth/Login.vue'
import ForgetPassword from 'src/components/Auth/ForgetPassword.vue'
// Admin pages
//import Overview from 'src/components/Dashboard/Views/Overview.vue'
//import UserProfile from 'src/components/Dashboard/Views/UserProfile.vue'
//import TableList from 'src/components/Dashboard/Views/TableList.vue'
//import Typography from 'src/components/Dashboard/Views/Typography.vue'
//import Icons from 'src/components/Dashboard/Views/Icons.vue'
//import Maps from 'src/components/Dashboard/Views/Maps.vue'
//import Notifications from 'src/components/Dashboard/Views/Notifications.vue'
//
// Trending Playlists
import TrendingPlaylists from '../components/Dashboard/Views/TrendingPlaylists/TrendingPlaylists.vue'
import CreateTrendingPlaylist from '../components/Dashboard/Views/TrendingPlaylists/CreateTrendingPlaylist.vue'
import EditTrendingPlaylist from '../components/Dashboard/Views/TrendingPlaylists/EditTrendingPlaylist.vue'
import TrendingPlaylistDetail from '../components/Dashboard/Views/TrendingPlaylists/TrendingPlaylistDetails.vue'
// Playlists
import Playlists from '../components/Dashboard/Views/Playlists/Playlists.vue'
import CreatePlaylist from '../components/Dashboard/Views/Playlists/CreatePlaylist.vue'
import EditPlaylist from '../components/Dashboard/Views/Playlists/EditPlaylist.vue'
import PlaylistDetail from '../components/Dashboard/Views/Playlists/PlaylistDetails.vue'
// Resource Groups
import Groups from '../components/Dashboard/Views/Groups/Groups.vue'
import CreateGroup from '../components/Dashboard/Views/Groups/CreateGroup.vue'
import EditGroup from '../components/Dashboard/Views/Groups/EditGroup.vue'
import GroupDetail from '../components/Dashboard/Views/Groups/GroupDetails.vue'
// Charities
import Charities from '../components/Dashboard/Views/Charities/Charities.vue'
import CreateCharity from '../components/Dashboard/Views/Charities/CreateCharity.vue'
import EditCharity from '../components/Dashboard/Views/Charities/EditCharity.vue'
import CharityDetail from '../components/Dashboard/Views/Charities/CharityDetails.vue'
// Messages
import Messages from '../components/Dashboard/Views/Messages/Messages.vue'
import CreateMessage from '../components/Dashboard/Views/Messages/CreateMessage.vue'
import EditMessage from '../components/Dashboard/Views/Messages/EditMessage.vue'
import MessageDetail from '../components/Dashboard/Views/Messages/MessageDetails.vue'
// Funnies
import Funnies from '../components/Dashboard/Views/Funnies/Funnies.vue'
import CreateFunny from '../components/Dashboard/Views/Funnies/CreateFunny.vue'
import EditFunny from '../components/Dashboard/Views/Funnies/EditFunny.vue'
import FunnyDetail from '../components/Dashboard/Views/Funnies/FunnyDetails.vue'

import Images from '../components/Dashboard/Views/ImageUpload.vue'
import EditDemoEvent from '../components/Dashboard/Views/EditDemoEvent.vue'
import VideoMetaDat from '../components/Dashboard/Views/VideoMetaDat.vue'
import DeleteVideosData from '../components/Dashboard/Views/DeleteVideosData.vue'
import ArchiveSync from '../components/Dashboard/Views/ArchiveSync.vue'
// Quotes
import Quotes from '../components/Dashboard/Views/Quotes/Quotes.vue'
import CreateQuote from '../components/Dashboard/Views/Quotes/CreateQuote.vue'
import EditQuote from '../components/Dashboard/Views/Quotes/EditQuote.vue'
import QuoteDetail from '../components/Dashboard/Views/Quotes/QuoteDetails.vue'

// logos
import Logos from '../components/Dashboard/Views/Logos/Logos.vue'
import CreateLogo from '../components/Dashboard/Views/Logos/CreateLogo.vue'
import EditLogo from '../components/Dashboard/Views/Logos/EditLogo.vue'
import LogoDetail from '../components/Dashboard/Views/Logos/LogoDetails.vue'
import OrderLogos from '../components/Dashboard/Views/Logos/OrderLogos.vue'
// Greetings
import Greetings from '../components/Dashboard/Views/Greetings/Greetings.vue'
import CreateGreeting from '../components/Dashboard/Views/Greetings/CreateGreeting'
import EditGreeting from '../components/Dashboard/Views/Greetings/EditGreeting'
import GreetingDetail from '../components/Dashboard/Views/Greetings/GreetingDetails.vue'
import GreetingOrder from '../components/Dashboard/Views/Greetings/OrderGreetings.vue'
// Persons
import Persons from '../components/Dashboard/Views/Persons/Persons.vue'
import CreatePerson from '../components/Dashboard/Views/Persons/CreatePerson'
import EditPerson from '../components/Dashboard/Views/Persons/EditPerson'
import PersonDetail from '../components/Dashboard/Views/Persons/PersonDetails.vue'
import PersonOrder from '../components/Dashboard/Views/Persons/OrderPersons.vue'
// FAQ Sections
import FAQSections from '../components/Dashboard/Views/FAQSect/FAQSections.vue'
import CreateFAQSection from '../components/Dashboard/Views/FAQSect/CreateFAQSection'
import EditFAQSection from '../components/Dashboard/Views/FAQSect/EditFAQSection'
import FAQSectionDetail from '../components/Dashboard/Views/FAQSect/FAQSectionDetails.vue'
// FAQ
import Faqs from '../components/Dashboard/Views/Faqs/Faqs.vue'
import CreateFaq from '../components/Dashboard/Views/Faqs/CreateFaq.vue'
import EditFaq from '../components/Dashboard/Views/Faqs/EditFaq.vue'
import FaqDetail from '../components/Dashboard/Views/Faqs/FaqDetails.vue'
// Account Recovery
import Account from '../components/Dashboard/Views/Account/Accounts.vue'
import CreateAccount from '../components/Dashboard/Views/Account/CreateAccount.vue'

// Articles
import Articles from '../components/Dashboard/Views/Articles/Articles.vue'
import CreateArticle from '../components/Dashboard/Views/Articles/CreateArticle'
import EditArticle from '../components/Dashboard/Views/Articles/EditArticle'
import ArticleDetail from '../components/Dashboard/Views/Articles/ArticleDetails.vue'
// Press Room
import Press from '../components/Dashboard/Views/Press/Press.vue'
import CreatePress from '../components/Dashboard/Views/Press/CreatePress.vue'
import EditPress from '../components/Dashboard/Views/Press/EditPress.vue'
import PressDetail from '../components/Dashboard/Views/Press/PressDetails.vue'
// Pinned Messages
import PinnedMsgs from '../components/Dashboard/Views/PinnedMsgs/PinnedMsgs.vue'
import CreatePinnedMsg from '../components/Dashboard/Views/PinnedMsgs/CreatePinnedMsg.vue'
import EditPinnedMsg from '../components/Dashboard/Views/PinnedMsgs/EditPinnedMsg.vue'
import PinnedMsgDetail from '../components/Dashboard/Views/PinnedMsgs/PinnedMsgDetails.vue'
//Experts
import Experts from '../components/Dashboard/Views/Experts/Experts.vue'
import ExpertDetails from '../components/Dashboard/Views/Experts/ExpertDetails.vue'
import CreateExpert from '../components/Dashboard/Views/Experts/CreateExpert.vue'
import EditExpert from '../components/Dashboard/Views/Experts/EditExpert.vue'
import OrderExperts from '../components/Dashboard/Views/Experts/OrderExperts.vue'
//Events
import Events from '../components/Dashboard/Views/Events/Events.vue'
import EditEvent from '../components/Dashboard/Views/Events/EditEvent.vue'
import EventDetails from '../components/Dashboard/Views/Events/EventDetails.vue'
import createEvent from '../components/Dashboard/Views/Events/CreateEvent.vue'
import OrderArchiveEvents from '../components/Dashboard/Views/Events/OrderArchiveEvents.vue'
//Teaser Templates
import TeaserTemplate from '../components/Dashboard/Views/Teaser/TeaserTemplate.vue'
import TeaserTemplateEdit from '../components/Dashboard/Views/Teaser/TeaserTemplateEdit.vue'
import CreateTeaserLine from '../components/Dashboard/Views/Teaser/CreateTeaserLine.vue'
//Events
import Testimonials from '../components/Dashboard/Views/Testimonials/Testimonials.vue'
import EditTestimonial from '../components/Dashboard/Views/Testimonials/EditTestimonial.vue'
import TestimonialDetails from '../components/Dashboard/Views/Testimonials/TestimonialDetails.vue'
import CreateTestimonial from '../components/Dashboard/Views/Testimonials/CreateTestimonial.vue'
import OrderTestimonials from '../components/Dashboard/Views/Testimonials/OrderTestimonials.vue'

//Resources
import Resources from '../components/Dashboard/Views/Resources/Resources.vue'
import EditResource from '../components/Dashboard/Views/Resources/EditResource.vue'
import ResourcesDetails from '../components/Dashboard/Views/Resources/ResourceDetails.vue'
import CreateResource from '../components/Dashboard/Views/Resources/CreateResource.vue'
import OrderResources from '../components/Dashboard/Views/Resources/OrderResources.vue'

//Contents
import Contents from '../components/Dashboard/Views/Contents/Contents.vue'
import ContentDetails from '../components/Dashboard/Views/Contents/ContentDetails.vue'
//Tags
import Tags from '../components/Dashboard/Views/Tags/Tags.vue'
import TagDetails from '../components/Dashboard/Views/Tags/TagDetails.vue'
//Configurations
import Configurations from '../components/Dashboard/Views/Configurations/Configurations.vue'
//Plans
import Plans from '../components/Dashboard/Views/Plans/Plans.vue'
import EditPlan from '../components/Dashboard/Views/Plans/EditPlan.vue'
import PlanDetails from '../components/Dashboard/Views/Plans/PlanDetails.vue'
import CreatePlan from '../components/Dashboard/Views/Plans/CreatePlan.vue'

//Corporations
import Corporations from '../components/Dashboard/Views/Corporations/Corporations.vue'
import EditCorporation from '../components/Dashboard/Views/Corporations/EditCorporation.vue'
import CorporationDetails from '../components/Dashboard/Views/Corporations/CorporationDetails.vue'
import CreateCorporation from '../components/Dashboard/Views/Corporations/CreateCorporation.vue'
//Parent Corporations
import ParentCorps from '../components/Dashboard/Views/ParentCorps/ParentCorps.vue'
import EditParentCorp from '../components/Dashboard/Views/ParentCorps/EditParentCorp.vue'
import ParentCorpDetails from '../components/Dashboard/Views/ParentCorps/ParentCorpDetails.vue'
import CreateParentCorp from '../components/Dashboard/Views/ParentCorps/CreateParentCorp.vue'

// import Charities from '../components/Dashboard/Views/Charities.vue'
// import Cancelation from '../components/Dashboard/Views/Cancelation.vue'
import Subscriber from '../components/Dashboard/Views/Subscriber.vue'
// import Registration from '../components/Dashboard/Views/Registration.vue'
import UserAccounts from '../components/Dashboard/Views/UserAccounts.vue'
import EditUserAccount from '../components/Dashboard/Views/EditUserAccount.vue'
import SuperAccounts from '../components/Dashboard/Views/SuperAccounts.vue'
import EditSuperAccount from '../components/Dashboard/Views/EditSuperAccount.vue'
//Gift pages
import Gifts from '../components/Dashboard/Views/Gifts/Gifts.vue'
import EditGift from '../components/Dashboard/Views/Gifts/EditGift.vue'
import GiftDetails from '../components/Dashboard/Views/Gifts/GiftDetails.vue'
import createGift from '../components/Dashboard/Views/Gifts/CreateGift.vue'
//home pages
import Content from '../components/Dashboard/Layout/Content.vue'
import HeroBanner from '../components/Dashboard/Views/Home/HeroBanner.vue'
// import Category from '../components/Dashboard/Views/Home/Category.vue'
// import Videos from '../components/Dashboard/Views/Home/Videos.vue'
// import Newsletter from '../components/Dashboard/Views/Home/Newsletter.vue'
import EmailTemplate from '../components/Dashboard/Views/EmailTemplate.vue'
// import EditParentCorp from "../components/Dashboard/Views/ParentCorps/EditParentCorp";
// PODCAST
import PodcastList from '../components/Dashboard/Views/Podcast/PodcastList.vue'
import CreatePodcast from '../components/Dashboard/Views/Podcast/CreatePodcast.vue'
import EditPodcast from '../components/Dashboard/Views/Podcast/EditPodcast.vue'
// ADVISORY BOARD
import AdvisoryBoardList from '../components/Dashboard/Views/Podcast/AdvisoryBoardList.vue'
import CreateAdvisoryBoard from '../components/Dashboard/Views/Podcast/CreateAdvisoryBoard.vue'
import EditAdvisoryBoard from '../components/Dashboard/Views/Podcast/EditAdvisoryBoard.vue'

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta : {
            isAuthRequire: false,
            title:'Login'
        }
    },
    {
        path: '/forget-password',
        name: 'Forget Password',
        component: ForgetPassword,
        meta : {
            isAuthRequire: false,
            title:'Forget Password'
        }
    },
    {
        path: '/',
        component: DashboardLayout,
        redirect: '/admin/home/hero-banner',
        meta : {isAuthRequire: true}
    },
    {
        path: '/admin',
        name: 'Admin',
        component: DashboardLayout,
        redirect: '/admin/home/hero-banner',
        meta : {isAuthRequire: true, title:'Admin', display: true},
        children: [
            {
                path: '/admin/home',
                name: 'Home',
                icon:'nc-app',
                component: Content,
                redirect: '/admin/home/hero-banner',
                meta : {isAuthRequire: true, title:'Home', display: true, childDisplay: false},
                children: [
                    {
                        path: '/admin/home/hero-banner',
                        name: 'Admin Panel',
                        component: HeroBanner,
                        meta : {isAuthRequire: true, title:'Admin Panel - Home', display: true}
                    },
                    // {
                    //     path: '/admin/home/category-blurbs',
                    //     name: 'Category blurbs',
                    //     component: Category,
                    //     meta : {isAuthRequire: true, title:'Category blurbs', display: true}
                    // },
                    // {
                    //     path: '/admin/home/videos',
                    //     name: 'Videos',
                    //     component: Videos,
                    //     meta : {isAuthRequire: true, title:'Videos', display: true}
                    // },
                    // {
                    //     path: '/admin/home/signup-newsletter',
                    //     name: 'Newsletter',
                    //     component: Newsletter,
                    //     meta : {isAuthRequire: true, title:'Newsletter', display: true}
                    // }
                ]
            },
          {
            path: '/admin/funnies',
            name: 'Funnies',
            icon:'nc-badge',
            component: Content,
            redirect: '/admin/funnies/list',
            meta : {isAuthRequire: true, title:'Funnies', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/funnies/list',
                name: 'Funnies',
                icon:'nc-paper-2',
                component: Funnies,
                children:[],
                meta : {isAuthRequire: true, title:'Funnies', display: false}
              },
              {
                path: '/admin/funny/:id',
                name: 'EditFunny',
                component: EditFunny,
                children:[],
                meta : {isAuthRequire: true, title:'Funnies', display: false}
              },
              {
                path: '/admin/funny/create',
                name: 'CreateFunny',
                component: CreateFunny,
                children:[],
                meta : {isAuthRequire: true, title:'Funnies', display: false}
              },
              {
                path: '/admin/funnies/view/:id',
                name: 'ViewFunny',
                component: FunnyDetail,
                children:[],
                meta : {isAuthRequire: true, title:'Funnies', display: false}
              }
            ]
          },
          {
            path: '/admin/fileupload',
            name: 'File Upload',
            icon:'nc-album-2',
            component: Images,
            children:[],
            meta : {isAuthRequire: true, title:'File Upload', display: true}
          },
          {
            path: '/admin/demo/event',
            name: 'Demo Event',
            icon:'nc-album-2',
            component: EditDemoEvent,
            children:[],
            meta : {isAuthRequire: true, title:'Demo Event', display: true}
          },
          {
            path: '/admin/metadata/sync-video',
            name: 'Sync Videos Metadata',
            icon:'nc-refresh-02',
            component: VideoMetaDat,
            children:[],
            meta : {isAuthRequire: true, title:'Add Video Metadata', display: true}
          },
          {
            path: '/admin/metadata/remove-video',
            name: 'Remove Videos Metadata',
            icon:'nc-refresh-02',
            component: DeleteVideosData,
            children:[],
            meta : {isAuthRequire: true, title:'Remove Video Metadata', display: true}
          },
          {
            path: '/admin/sync/event',
            name: 'Sync Archive Event',
            icon:'nc-refresh-02',
            component: ArchiveSync,
            children:[],
            meta : {isAuthRequire: true, title:'Sync Archive Event', display: true}
          },
          // --------------------------- PODCAST
          {
            path: '/admin/podcasts',
            name: 'Podcasts',
            icon:'nc-puzzle-10',
            component: Content,
            redirect: '/admin/podcasts/list',
            meta : {isAuthRequire: true, title:'Podcasts', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/podcasts/list',
                name: 'PodcastsList',
                icon:'nc-puzzle-10',
                component: PodcastList,
                children:[],
                meta : {isAuthRequire: true, title:'Podcasts', display: false}
              },
              {
                path: '/admin/podcasts/:id',
                name: 'EditPodcast',
                component: EditPodcast,
                children:[],
                meta : {isAuthRequire: true, title:'Podcasts', display: false}
              },
              {
                path: '/admin/podcasts/create',
                name: 'CreatePodcast',
                component: CreatePodcast,
                children:[],
                meta : {isAuthRequire: true, title:'Podcasts', display: false}
              }
            ]
          },
          {
            path: '/admin/advisoryboard',
            name: 'Advisory Board',
            icon:'nc-circle-09',
            component: Content,
            redirect: '/admin/advisoryboard/list',
            meta : {isAuthRequire: true, title:'Advisory Board', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/advisoryboard/list',
                name: 'Advisory Board List',
                icon:'nc-puzzle-10',
                component: AdvisoryBoardList,
                children:[],
                meta : {isAuthRequire: true, title:'Advisory Board', display: false}
              },
              {
                path: '/admin/advisoryboard/editadvboard/:advisoryBoardId',
                name: 'EditAdvisoryBoard',
                icon:'nc-puzzle-10',
                component: EditAdvisoryBoard,
                children:[],
                meta : {isAuthRequire: true, title:'Advisory Board', display: false}
              },
              {
                path: '/admin/advisoryboard/create',
                name: 'CreateAdvisoryBoard',
                icon:'nc-puzzle-10',
                component: CreateAdvisoryBoard,
                children:[],
                meta : {isAuthRequire: true, title:'Advisory Board', display: false}
              }
            ]
          },
          {
            path: '/admin/email/email-template',
            name: 'Email Template',
            icon:'nc-album-2',
            component: EmailTemplate,
            children:[],
            meta : {isAuthRequire: true, title:'Email Template', display: true}
          },
          {
            path: '/admin/quotes',
            name: 'Quotes',
            icon:'nc-bullet-list-67',
            component: Content,
            redirect: '/admin/quotes/list',
            meta : {isAuthRequire: true, title:'Quotes', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/quotes/list',
                name: 'quotes',
                icon:'nc-paper-2',
                component: Quotes,
                children:[],
                meta : {isAuthRequire: true, title:'Quotes', display: false}
              },
              {
                path: '/admin/quotes/editquotes/:id',
                name: 'EditQuote',
                component: EditQuote,
                children:[],
                meta : {isAuthRequire: true, title:'Quotes', display: false}
              },
              {
                path: '/admin/quotes/create',
                name: 'CreateQuote',
                component: CreateQuote,
                children:[],
                meta : {isAuthRequire: true, title:'Quotes', display: false}
              },
              {
                path: '/admin/quotes/view/:id',
                name: 'QuoteDetail',
                component: QuoteDetail,
                children:[],
                meta : {isAuthRequire: true, title:'Quotes', display: false}
              }
            ]
          },
          {
            path: '/admin/faqsections',
            name: 'FAQ Sections',
            icon:'nc-html5',
            component: Content,
            redirect: '/admin/faqsections/list',
            meta : {isAuthRequire: true, title:'FAQ Sections', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/faqsections/list',
                name: 'FAQ Sections',
                icon:'nc-paper-2',
                component: FAQSections,
                children:[],
                meta : {isAuthRequire: true, title:'FAQ Sections', display: false}
              },
              {
                path: '/admin/article/editfaqsection/:id',
                name: 'EditFAQSection',
                component: EditFAQSection,
                children:[],
                meta : {isAuthRequire: true, title:'FAQ Sections', display: false}
              },
              {
                path: '/admin/faqsection/create',
                name: 'CreateFAQSection',
                component: CreateFAQSection,
                children:[],
                meta : {isAuthRequire: true, title:'FAQ Sections', display: false}
              },
              {
                path: '/admin/faqsection/view/:id',
                name: 'FAQSectionDetail',
                component: FAQSectionDetail,
                children:[],
                meta : {isAuthRequire: true, title:'FAQ Section', display: false}
              }
            ]
          },
          {
            path: '/admin/faqs',
            name: 'FAQ',
            icon:'nc-light-3',
            component: Content,
            redirect: '/admin/faqs/list',
            meta : {isAuthRequire: true, title:'FAQ', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/faqs/list',
                name: 'FAQ',
                icon:'nc-paper-2',
                component: Faqs,
                children:[],
                meta : {isAuthRequire: true, title:'FAQ', display: false}
              },
              {
                path: '/admin/faq/editfaqs/:id',
                name: 'EditFaq',
                component: EditFaq,
                children:[],
                meta : {isAuthRequire: true, title:'FAQ', display: false}
              },
              {
                path: '/admin/faqs/create',
                name: 'CreateFaq',
                component: CreateFaq,
                children:[],
                meta : {isAuthRequire: true, title:'FAQ', display: false}
              },
              {
                path: '/admin/faqs/view/:id',
                name: 'FaqDetail',
                component: FaqDetail,
                children:[],
                meta : {isAuthRequire: true, title:'FAQ', display: false}
              }
            ]
          },
          {
            path: '/admin/accounts',
            name: 'Account',
            icon:'nc-circle-09',
            component: Content,
            redirect: '/admin/accounts/list',
            meta : {isAuthRequire: true, title:'Account Recovery', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/accounts/list',
                name: 'Account',
                icon:'nc-circle-09',
                component: Account,
                children:[],
                meta : {isAuthRequire: true, title:'Account Recovery', display: false}
              },
              {
                path: '/admin/account-recovery/recover',
                name: 'CreateAccount',
                component: CreateAccount,
                children:[],
                meta : {isAuthRequire: true, title:'Account Recovery', display: false}
              }
            ]
          },
          {
            path: '/admin/articles',
            name: 'Articles',
            icon:'nc-sun-fog-29',
            component: Content,
            redirect: '/admin/articles/list',
            meta : {isAuthRequire: true, title:'Articles', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/articles/list',
                name: 'Articles',
                icon:'nc-paper-2',
                component: Articles,
                children:[],
                meta : {isAuthRequire: true, title:'Articles', display: false}
              },
              {
                path: '/admin/article/editarticle/:id',
                name: 'EditArticle',
                component: EditArticle,
                children:[],
                meta : {isAuthRequire: true, title:'Articles', display: false}
              },
              {
                path: '/admin/article/create',
                name: 'CreateArticle',
                component: CreateArticle,
                children:[],
                meta : {isAuthRequire: true, title:'Articles', display: false}
              },
              {
                path: '/admin/article/view/:id',
                name: 'ArticleDetail',
                component: ArticleDetail,
                children:[],
                meta : {isAuthRequire: true, title:'Articles', display: false}
              }
            ]
          },
          {
            path: '/admin/tonepress',
            name: 'Press Room',
            icon:'nc-credit-card',
            component: Content,
            redirect: '/admin/press/list',
            meta : {isAuthRequire: true, title:'TONE Press Room', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/press/list',
                name: 'Press Room',
                icon:'nc-credit-card',
                component: Press,
                children:[],
                meta : {isAuthRequire: true, title:'TONE Press Room', display: false}
              },
              {
                path: '/admin/press/editpress/:id',
                name: 'EditPress',
                component: EditPress,
                children:[],
                meta : {isAuthRequire: true, title:'TONE Press Room', display: false}
              },
              {
                path: '/admin/press/create',
                name: 'CreatePress',
                component: CreatePress,
                children:[],
                meta : {isAuthRequire: true, title:'TONE Press Room', display: false}
              },
              {
                path: '/admin/press/view/:id',
                name: 'PressDetail',
                component: PressDetail,
                children:[],
                meta : {isAuthRequire: true, title:'TONE Press Room', display: false}
              }
            ]
          },
          {
            path: '/admin/persons',
            name: 'Persons',
            icon:'nc-single-02',
            component: Content,
            redirect: '/admin/persons/list',
            meta : {isAuthRequire: true, title:'Staff Members', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/persons/list',
                name: 'Persons',
                icon:'nc-single-02',
                component: Persons,
                children:[],
                meta : {isAuthRequire: true, title:'Staff Members', display: false}
              },
              {
                path: '/admin/person/editperson/:id',
                name: 'EditPerson',
                component: EditPerson,
                children:[],
                meta : {isAuthRequire: true, title:'Staff Members', display: false}
              },
              {
                path: '/admin/person/create',
                name: 'CreatePerson',
                component: CreatePerson,
                children:[],
                meta : {isAuthRequire: true, title:'Staff Members', display: false}
              },
              {
                path: '/admin/person/view/:id',
                name: 'PersonDetail',
                component: PersonDetail,
                children:[],
                meta : {isAuthRequire: true, title:'Staff Members', display: false}
              },
              {
                path: '/admin/person/sorting',
                name: 'PersonOrdering',
                component: PersonOrder,
                children:[],
                meta : {isAuthRequire: true, title:'Staff Members', display: false}
              },
            ]
          },
          {
            path: '/admin/greetings',
            name: 'Greetings',
            icon:'nc-chat-round',
            component: Content,
            redirect: '/admin/greetings/list',
            meta : {isAuthRequire: true, title:'Greetings', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/greetings/list',
                name: 'Greetings',
                icon:'nc-paper-2',
                component: Greetings,
                children:[],
                meta : {isAuthRequire: true, title:'Greetings', display: false}
              },
              {
                path: '/admin/greeting/editgreeting/:id',
                name: 'EditGreeting',
                component: EditGreeting,
                children:[],
                meta : {isAuthRequire: true, title:'Greetings', display: false}
              },
              {
                path: '/admin/greeting/create',
                name: 'CreateGreeting',
                component: CreateGreeting,
                children:[],
                meta : {isAuthRequire: true, title:'Greetings', display: false}
              },
              {
                path: '/admin/greeting/view/:id',
                name: 'GreetingDetail',
                component: GreetingDetail,
                children:[],
                meta : {isAuthRequire: true, title:'Greetings', display: false}
              },
              {
                path: '/admin/greeting/sorting',
                name: 'Greeting Ordering',
                component: GreetingOrder,
                children:[],
                meta : {isAuthRequire: true, title:'Greetings Order', display: false}
              },
            ]
          },
          {
                path: '/admin/experts',
                name: 'Experts',
                icon:'nc-puzzle-10',
                component: Content,
                redirect: '/admin/experts/list',
                meta : {isAuthRequire: true, title:'Experts', display: true, childDisplay:false},
                children:[
                    {
                        path: '/admin/experts/list',
                        name: 'Experts',
                        icon:'nc-puzzle-10',
                        component: Experts,
                        children:[],
                        meta : {isAuthRequire: true, title:'Experts', display: false}
                    },
                    {
                        path: '/admin/experts/sorting',
                        name: 'Experts Ordering',
                        component: OrderExperts,
                        children:[],
                        meta : {isAuthRequire: true, title:'Experts', display: false}
                    },
                    {
                        path: '/admin/experts/:id',
                        name: 'EditExpert',
                        component: EditExpert,
                        children:[],
                        meta : {isAuthRequire: true, title:'Experts', display: false}
                    },
                    {
                        path: '/admin/expert/create',
                        name: 'CreateExpert',
                        component: CreateExpert,
                        children:[],
                        meta : {isAuthRequire: true, title:'Experts', display: false}
                    },
                    {
                        path: '/admin/experts/view/:id',
                        name: 'ViewExpert',
                        component: ExpertDetails,
                        children:[],
                        meta : {isAuthRequire: true, title:'Experts', display: false}
                    }
                ]
            },

            /*{
                path: '/admin/experts',
                name: 'Experts',
                icon:'nc-puzzle-10',
                component: Experts,
                children:[],
                meta : {isAuthRequire: true, title:'Experts', display: true}
            },
            {
                path: '/admin/experts/:id',
                name: 'EditExpert',
                component: EditExpert,
                children:[],
                meta : {isAuthRequire: true, title:'Experts', display: false}
            },
            {
                path: '/admin/expert/create',
                name: 'CreateExpert',
                component: CreateExpert,
                children:[],
                meta : {isAuthRequire: true, title:'Experts', display: false}
            },
            {
                path: '/admin/experts/view/:id',
                name: 'ViewExpert',
                component: ExpertDetails,
                children:[],
                meta : {isAuthRequire: true, title:'Experts', display: false}
            },*/

            {
                path: '/admin/events',
                name: 'Events',
                icon:'nc-paper-2',
                component: Content,
                redirect: '/admin/events/list',
                meta : {isAuthRequire: true, title:'Events', display: true, childDisplay:false},
                children:[
                    {
                        path: '/admin/events/list',
                        name: 'Events',
                        icon:'nc-paper-2',
                        component: Events,
                        children:[],
                        meta : {isAuthRequire: true, title:'Events', display: false}
                    },
                    {
                        path: '/admin/events/:id',
                        name: 'EditEvent',
                        component: EditEvent,
                        children:[],
                        meta : {isAuthRequire: true, title:'Events', display: false}
                    },
                    {
                        path: '/admin/event/create',
                        name: 'CreateEvent',
                        component: createEvent,
                        children:[],
                        meta : {isAuthRequire: true, title:'Events', display: false}
                    },
                    {
                        path: '/admin/events/view/:id',
                        name: 'ViewEvent',
                        component: EventDetails,
                        children:[],
                        meta : {isAuthRequire: true, title:'Events', display: false}
                    },
                    {
                      path: '/admin/event/sorting',
                      name: 'Order Archive Events',
                      component: OrderArchiveEvents,
                      children:[],
                      meta : {isAuthRequire: true, title:'Events Ordering', display: false}
                    }
                ]
            },
            {
              path: '/admin/contents',
              name: 'Contents',
              icon:'nc-caps-small',
              component: Content,
              redirect: '/admin/contents/list',
              meta : {isAuthRequire: true, title:'Contents', display: true, childDisplay:false},
              children:[
                {
                  path: '/admin/contents/list',
                  name: 'Contents',
                  icon:'nc-caps-small',
                  component: Contents,
                  children:[],
                  meta : {isAuthRequire: true, title:'Contents', display: false}
                },
                {
                  path: '/admin/contents/view/:id',
                  name: 'ViewContent',
                  component: ContentDetails,
                  children:[],
                  meta : {isAuthRequire: true, title:'Contents', display: false}
                }

              ]
            },
          {
            path: '/admin/tags',
            name: 'Tags',
            icon:'nc-layers-3',
            component: Content,
            redirect: '/admin/tags/list',
            meta : {isAuthRequire: true, title:'Meta-Tags', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/tags/list',
                name: 'Tags',
                icon:'nc-layers-3',
                component: Tags,
                children:[],
                meta : {isAuthRequire: true, title:'Meta-Tags', display: false}
              },
              {
                path: '/admin/tags/view/:id',
                name: 'ViewTag',
                component: TagDetails,
                children:[],
                meta : {isAuthRequire: true, title:'Meta-Tags', display: false}
              }

            ]
          },
            {
              path: '/admin/configurations',
              name: 'Configurations',
              icon:'nc-settings-gear-64',
              component: Configurations,
              redirect: '/admin/configurations/list',
              meta : {isAuthRequire: true, title:'Configurations', display: true, childDisplay:false},
              children:[
                {
                  path: '/admin/configurations/list',
                  name: 'Configurations',
                  icon:'nc-settings-gear-64',
                  component: Configurations,
                  children:[],
                  meta : {isAuthRequire: true, title:'Configurations', display: false}
                }

              ]
            },

            {
            path: '/admin/testimonials',
            name: 'Testimonials',
            icon:'nc-paper-2',
            component: Content,
            redirect: '/admin/testimonials/list',
            meta : {isAuthRequire: true, title:'Testimonials', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/testimonials/list',
                name: 'Testimonials',
                icon:'nc-paper-2',
                component: Testimonials,
                children:[],
                meta : {isAuthRequire: true, title:'Testimonials', display: false}
              },
              {
                path: '/admin/testimonials/:id',
                name: 'EditTestimonial',
                component: EditTestimonial,
                children:[],
                meta : {isAuthRequire: true, title:'Testimonials', display: false}
              },
              {
                path: '/admin/testimonial/create',
                name: 'CreateTestimonial',
                component: CreateTestimonial,
                children:[],
                meta : {isAuthRequire: true, title:'Testimonials', display: false}
              },
              {
                path: '/admin/testimonials/view/:id',
                name: 'ViewTestimonial',
                component: TestimonialDetails,
                children:[],
                meta : {isAuthRequire: true, title:'Testimonials', display: false}
              },
              {
                path: '/admin/testimonials/sorting',
                name: 'Testimonial Ordering',
                component: OrderTestimonials,
                children:[],
                meta : {isAuthRequire: true, title:'Company Logos (Sorting)', display: false}
              }
            ]
          },
          {
            path: '/admin/resources',
            name: 'Resources',
            icon:'nc-paper-2',
            component: Content,
            redirect: '/admin/resources/list',
            meta : {isAuthRequire: true, title:'Resources', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/resources/list',
                name: 'resources',
                icon:'nc-paper-2',
                component: Resources,
                children:[],
                meta : {isAuthRequire: true, title:'Resources', display: false}
              },
              {
                path: '/admin/resource/:id',
                name: 'EditResource',
                component: EditResource,
                children:[],
                meta : {isAuthRequire: true, title:'Resources', display: false}
              },
              {
                path: '/admin/resource/create',
                name: 'CreateResource',
                component: CreateResource,
                children:[],
                meta : {isAuthRequire: true, title:'Resources', display: false}
              },
              {
                path: '/admin/resources/view/:id',
                name: 'ViewResource',
                component: ResourcesDetails,
                children:[],
                meta : {isAuthRequire: true, title:'Resources', display: false}
              },
              {
                path: '/admin/resources/sorting',
                name: 'Resource Ordering',
                component: OrderResources,
                children:[],
                meta : {isAuthRequire: true, title:'Resource Article (Sorting)', display: false}
              }
            ]
          },
          {
            path: '/admin/messages',
            name: 'Messages',
            icon:'nc-layers-3',
            component: Content,
            redirect: '/admin/messages/list',
            meta : {isAuthRequire: true, title:'Messages', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/messages/list',
                name: 'Messages',
                icon:'nc-paper-2',
                component: Messages,
                children:[],
                meta : {isAuthRequire: true, title:'Messages', display: false}
              },
              {
                path: '/admin/message/editmessage/:id',
                name: 'EditMessage',
                component: EditMessage,
                children:[],
                meta : {isAuthRequire: true, title:'Messages', display: false}
              },
              {
                path: '/admin/message/create',
                name: 'CreateMessage',
                component: CreateMessage,
                children:[],
                meta : {isAuthRequire: true, title:'Messages', display: false}
              },
              {
                path: '/admin/message/view/:id',
                name: 'MessageDetail',
                component: MessageDetail,
                children:[],
                meta : {isAuthRequire: true, title:'Messages', display: false}
              }
            ]
          },

            /*{
                path: '/admin/events',
                name: 'Events',
                icon:'nc-paper-2',
                component: Events,
                children:[],
                meta : {isAuthRequire: true, title:'Events', display: true}
            },
            {
                path: '/admin/events/:id',
                name: 'EditEvent',
                component: EditEvent,
                children:[],
                meta : {isAuthRequire: true, title:'Events', display: false}
            },
            {
                path: '/admin/event/create',
                name: 'CreateEvent',
                component: createEvent,
                children:[],
                meta : {isAuthRequire: true, title:'Events', display: false}
            },
            {
                path: '/admin/events/view/:id',
                name: 'ViewEvent',
                component: EventDetails,
                children:[],
                meta : {isAuthRequire: true, title:'Events', display: false}
            },*/

          {
            path: '/admin/charities',
            name: 'Charities',
            icon:'nc-money-coins',
            component: Content,
            redirect: '/admin/charities/list',
            meta : {isAuthRequire: true, title:'Charities', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/charities/list',
                name: 'Charities',
                icon:'nc-money-coins',
                component: Charities,
                children:[],
                meta : {isAuthRequire: true, title:'Charities', display: false}
              },
              {
                path: '/admin/charities/editcharity/:id',
                name: 'EditCharity',
                component: EditCharity,
                children:[],
                meta : {isAuthRequire: true, title:'Charities', display: false}
              },
              {
                path: '/admin/faqs/create',
                name: 'CreateCharity',
                component: CreateCharity,
                children:[],
                meta : {isAuthRequire: true, title:'Charities', display: false}
              },
              {
                path: '/admin/charities/view/:id',
                name: 'CharityDetail',
                component: CharityDetail,
                children:[],
                meta : {isAuthRequire: true, title:'Charities', display: false}
              }
            ]
          },
            // {
            //     path: '/admin/gift',
            //     name: 'Gift',
            //     icon:'nc-backpack',
            //     component: GiftContent,
            //     redirect: '/admin/gift/generate',
            //     meta : {isAuthRequire: true, title:'Gift', display: true},
            //     children:[
            //         {
            //             path: '/admin/gift/generate',
            //             name: 'Generate',
            //             component: Generate,
            //             meta : {isAuthRequire: true, title:'Gift Generate', display: true}
            //         },
            //         {
            //             path: '/admin/gift/template',
            //             name: 'Template',
            //             component: Templates,
            //             meta : {isAuthRequire: true, title:'Gift Template', display: true}
            //         }
            //     ]
            // },
            // {
            //     path: '/admin/cancelation',
            //     name: 'Cancelation',
            //     icon:'nc-simple-remove',
            //     component: Cancelation,
            //     children:[],
            //     meta : {isAuthRequire: true, title:'Cancelation', display: true}
            // },
            // {
            //     path: '/admin/subscriber-reports',
            //     name: 'Subscriber Reports',
            //     icon:'nc-email-85',
            //     component: Subscriber,
            //     children:[],
            //     meta : {isAuthRequire: true, title:'Subscriber Reports', display: true}
            // },
            // {
            //     path: '/admin/registration-flow',
            //     name: 'Registration Flow',
            //     icon:'nc-bell-55',
            //     component: Registration,
            //     children:[],
            //     meta : {isAuthRequire: true, title:'Registration Flow', display: true}
            // },
          //   {
          //       path: '/admin/user-accounts',
          //       name: 'User Accounts',
          //       icon:'nc-circle-09',
          //       component: UserAccounts,
          //       children:[],
          //       meta : {isAuthRequire: true, title:'User Accounts', display: true}
          //   },
          // {
          //   path: '/admin/user-accounts/edit/:id',
          //   name: 'EditUserAccount',
          //   icon:'nc-circle-09',
          //   component: EditUserAccount,
          //   children:[],
          //   meta : {isAuthRequire: true, title:'Edit User Account', display: true}
          // },
          {
            path: '/admin/user-accounts',
            name: 'User Accounts',
            icon:'nc-circle-09',
            component: Content,
            redirect: '/admin/user-accounts/list',
            meta : {isAuthRequire: true, title:'User Accounts', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/user-accounts/list',
                name: 'UserAccounts',
                icon:'nc-email-85',
                component: UserAccounts,
                children:[],
                meta : {isAuthRequire: true, title:'User Accounts', display: false}
              },
              {
                path: '/admin/user-accounts/edit/:id',
                name: 'EditUserAccount',
                icon:'nc-circle-09',
                component: EditUserAccount,
                children:[],
                meta : {isAuthRequire: true, title:'Edit User Account', display: false}
              }
            ]
          },
          {
            path: '/admin/super-accounts',
            name: 'Super User Defaults',
            icon:'nc-circle-09',
            component: Content,
            redirect: '/admin/super-accounts/list',
            meta : {isAuthRequire: true, title:'Super User Defaults', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/super-accounts/list',
                name: 'SuperAccounts',
                icon:'nc-email-85',
                component: SuperAccounts,
                children:[],
                meta : {isAuthRequire: true, title:'Super User Defaults', display: false}
              },
              {
                path: '/admin/super-accounts/:id/edit/:parentId',
                name: 'EditSuperAccount',
                icon:'nc-circle-09',
                component: EditSuperAccount,
                children:[],
                meta : {isAuthRequire: true, title:'Edit Super User Defaults', display: false}
              }
            ]
          },
            {
                path: '/admin/plan',
                name: 'Packages / Plans',
                icon:'nc-bulb-63',
                component: Content,
                redirect: '/admin/plan/list',
                meta : {isAuthRequire: true, title:'Home', display: true, childDisplay:false},
                children: [
                    {
                        path: '/admin/plan/list',
                        name: 'Packages / Plans',
                        component: Plans,
                        meta : {isAuthRequire: true, title:'Package / Plan', display: false}
                    },
                    {
                        path: '/admin/plan/create',
                        name: 'Create Plan',
                        component: CreatePlan,
                        children:[],
                        meta : {isAuthRequire: true, title:'Package / Plan', display: false}
                    },
                    {
                        path: '/admin/plan/edit/:id',
                        name: 'Edit Plan',
                        component: EditPlan,
                        children:[],
                        meta : {isAuthRequire: true, title:'Package / Plan', display: false}
                    },
                    {
                        path: '/admin/plan/view/:id',
                        name: 'Plan Details',
                        component: PlanDetails,
                        children:[],
                        meta : {isAuthRequire: true, title:'Package / Plan', display: false}
                    }
                ]
            },
          {
            path: '/admin/parent-corporations',
            name: 'Parent Corporations',
            icon:'nc-umbrella-13',
            component: Content,
            redirect: '/admin/parent-corporations/list',
            meta : {isAuthRequire: true, title:'Parent Corporations', display: true, childDisplay:false},
            children: [
              {
                path: '/admin/parent-corporations/list',
                name: 'Parent Corporations',
                component: ParentCorps,
                meta : {isAuthRequire: true, title:'Parent Corporations', display: false}
              },
              {
                path: '/admin/parent-corporation/create',
                name: 'Create Parent Corporation',
                component: CreateParentCorp,
                children:[],
                meta : {isAuthRequire: true, title:'Parent Corporations', display: false}
              },
              {
                path: '/admin/parent-corporation/edit/:id',
                name: 'Edit Parent Corporation',
                component: EditParentCorp,
                children:[],
                meta : {isAuthRequire: true, title:'Parent Corporations', display: false}
              },
              {
                path: '/admin/parent-corporation/view/:id',
                name: 'Parent Corporation Details',
                component: ParentCorpDetails,
                children:[],
                meta : {isAuthRequire: true, title:'Parent Corporations', display: false}
              }
            ]
          },
          {
            path: '/admin/groups',
            name: 'Groups',
            icon:'nc-tv-2',
            component: Content,
            redirect: '/admin/groups/list',
            meta : {isAuthRequire: true, title:'Groups', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/groups/list',
                name: 'Groups',
                icon:'nc-paper-2',
                component: Groups,
                children:[],
                meta : {isAuthRequire: true, title:'Groups', display: false}
              },
              {
                path: '/admin/group/editgroup/:id',
                name: 'Edit Group',
                component: EditGroup,
                children:[],
                meta : {isAuthRequire: true, title:'Edit Group', display: false}
              },
              {
                path: '/admin/group/create',
                name: 'Create Group',
                component: CreateGroup,
                children:[],
                meta : {isAuthRequire: true, title:'Create Group', display: false}
              },
              {
                path: '/admin/group/view/:id',
                name: 'Group Detail',
                component: GroupDetail,
                children:[],
                meta : {isAuthRequire: true, title:'Group Detail', display: false}
              }
            ]
          },
            {
                path: '/admin/corporations',
                name: 'Corporations',
                icon:'nc-vector',
                component: Content,
                redirect: '/admin/corporations/list',
                meta : {isAuthRequire: true, title:'Corporations', display: true, childDisplay:false},
                children: [
                    {
                        path: '/admin/corporations/list',
                        name: 'Corporations',
                        component: Corporations,
                        meta : {isAuthRequire: true, title:'Corporations', display: false}
                    },
                    {
                        path: '/admin/corporations/create',
                        name: 'Create Corporation',
                        component: CreateCorporation,
                        children:[],
                        meta : {isAuthRequire: true, title:'Corporations', display: false}
                    },
                    {
                        path: '/admin/corporations/edit/:id',
                        name: 'Edit Corporation',
                        component: EditCorporation,
                        children:[],
                        meta : {isAuthRequire: true, title:'Corporations', display: false}
                    },
                    {
                        path: '/admin/corporations/view/:id',
                        name: 'Corporation Details',
                        component: CorporationDetails,
                        children:[],
                        meta : {isAuthRequire: true, title:'Corporations', display: false}
                    }
                ]
            },
          {
            path: '/admin/gifts',
            name: 'Hybrid Gifting',
            icon:'nc-backpack',
            component: Content,
            redirect: '/admin/gifts/list',
            meta : {isAuthRequire: true, title:'Gifts', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/gifts/list',
                name: 'Hybrid Gifting',
                icon:'nc-backpack',
                component: Gifts,
                children:[],
                meta : {isAuthRequire: true, title:'Gifts', display: false}
              },
              {
                path: '/admin/gift/edit/:id',
                name: 'EditGift',
                component: EditGift,
                children:[],
                meta : {isAuthRequire: true, title:'Gifts', display: false}
              },
              {
                path: '/admin/gift/create',
                name: 'Create Gift',
                component: createGift,
                children:[],
                meta : {isAuthRequire: true, title:'Gifts', display: false}
              },
              {
                path: '/admin/gifts/view/:id',
                name: 'Gift Details',
                component: GiftDetails,
                children:[],
                meta : {isAuthRequire: true, title:'Gifts', display: false}
              }
            ]
          },
          {
            path: '/admin/pinnedmsgs',
            name: 'Pinned Messages',
            icon:'nc-pin-3',
            component: Content,
            redirect: '/admin/pinnedmsgs/list',
            meta : {isAuthRequire: true, title:'Corporation Pinned Messages', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/pinnedmsgs/list',
                name: 'Pinned Messages',
                icon:'nc-pin-3',
                component: PinnedMsgs,
                children:[],
                meta : {isAuthRequire: true, title:'Corporation Pinned Messages', display: false}
              },
              {
                path: '/admin/pinnedmsg/edit/:id',
                name: 'EditPinnedMsg',
                component: EditPinnedMsg,
                children:[],
                meta : {isAuthRequire: true, title:'Corporation Pinned Messages', display: false}
              },
              {
                path: '/admin/pinnedmsg/create',
                name: 'CreatePinnedMsg',
                component: CreatePinnedMsg,
                children:[],
                meta : {isAuthRequire: true, title:'Corporation Pinned Messages', display: false}
              },
              {
                path: '/admin/pinnedmsg/view/:id',
                name: 'PinnedMsgDetail',
                component: PinnedMsgDetail,
                children:[],
                meta : {isAuthRequire: true, title:'Corporation Pinned Messages', display: false}
              }
            ]
          },
          {
            path: '/admin/playlists',
            name: 'Playlists',
            icon:'nc-layers-3',
            component: Content,
            redirect: '/admin/playlists/list',
            meta : {isAuthRequire: true, title:'Playlists', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/playlists/list',
                name: 'Playlists',
                icon:'nc-paper-2',
                component: Playlists,
                children:[],
                meta : {isAuthRequire: true, title:'Playlists', display: false}
              },
              {
                path: '/admin/playlist/editplaylist/:id',
                name: 'Edit Playlist',
                component: EditPlaylist,
                children:[],
                meta : {isAuthRequire: true, title:'Playlists', display: false}
              },
              {
                path: '/admin/playlist/create',
                name: 'Create Playlist',
                component: CreatePlaylist,
                children:[],
                meta : {isAuthRequire: true, title:'Playlists', display: false}
              },
              {
                path: '/admin/playlist/view/:id',
                name: 'Playlist Detail',
                component: PlaylistDetail,
                children:[],
                meta : {isAuthRequire: true, title:'Playlists', display: false}
              }
            ]
          },
          {
            path: '/admin/trendingplaylists',
            name: 'TrendingPlaylists',
            icon:'nc-layers-3',
            component: Content,
            redirect: '/admin/trendingplaylists/list',
            meta : {isAuthRequire: true, title:'Trending Playlists', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/trendingplaylists/list',
                name: 'TrendingPlaylists',
                icon:'nc-paper-2',
                component: TrendingPlaylists,
                children:[],
                meta : {isAuthRequire: true, title:'Trending Playlists', display: false}
              },
              {
                path: '/admin/trendingplaylists/editplaylist/:id',
                name: 'Edit Trending Playlist',
                component: EditTrendingPlaylist,
                children:[],
                meta : {isAuthRequire: true, title:'Trending Playlists', display: false}
              },
              {
                path: '/admin/trendingplaylists/create',
                name: 'Create Trending Playlist',
                component: CreateTrendingPlaylist,
                children:[],
                meta : {isAuthRequire: true, title:'Trending Playlists', display: false}
              },
              {
                path: '/admin/trendingplaylists/view/:id',
                name: 'Trending Playlist Detail',
                component: TrendingPlaylistDetail,
                children:[],
                meta : {isAuthRequire: true, title:'Trending Playlists', display: false}
              }
            ]
          },
          {
            path: '/admin/logos',
            name: 'Logos',
            icon:'nc-tap-01',
            component: Content,
            redirect: '/admin/logos/list',
            meta : {isAuthRequire: true, title:'Company Logos', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/logos/list',
                name: 'logos',
                icon:'nc-tap-01',
                component: Logos,
                children:[],
                meta : {isAuthRequire: true, title:'Company Logos', display: false}
              },
              {
                path: '/admin/logos/editlogo/:id',
                name: 'EditLogo',
                component: EditLogo,
                children:[],
                meta : {isAuthRequire: true, title:'Company Logos', display: false}
              },
              {
                path: '/admin/logo/create',
                name: 'CreateLogo',
                component: CreateLogo,
                children:[],
                meta : {isAuthRequire: true, title:'Company Logos', display: false}
              },
              {
                path: '/admin/logo/view/:id',
                name: 'LogoDetail',
                component: LogoDetail,
                children:[],
                meta : {isAuthRequire: true, title:'Company Logos', display: false}
              },
              {
                path: '/admin/logos/sorting',
                name: 'Logo Ordering',
                component: OrderLogos,
                children:[],
                meta : {isAuthRequire: true, title:'Company Logos (Sorting)', display: false}
              }
            ]
          },
          {
            path: '/admin/teasertemplate',
            name: 'Teaser Template',
            icon:'nc-email-85',
            component: Content,
            redirect: '/admin/teasertemplate/list',
            meta : {isAuthRequire: true, title:'Teaser Templates', display: true, childDisplay:false},
            children:[
              {
                path: '/admin/teasertemplate/list',
                name: 'Teaser Template',
                icon:'nc-email-85',
                component: TeaserTemplate,
                children:[],
                meta : {isAuthRequire: true, title:'Teaser Templates', display: false}
              },
              {
                path: '/admin/logos/editteasertemplate/:contentType/:id',
                name: 'EditTeaserTemplate',
                component: TeaserTemplateEdit,
                children:[],
                meta : {isAuthRequire: true, title:'Teaser Templates', display: false}
              },
              {
                path: 'admin/teasertemplate/create',
                name: 'CreateTeaserLine',
                component: CreateTeaserLine,
                children:[],
                meta : {isAuthRequire: true, title:'New Teaser Line', display: false}
              }
            ]
          }
        ]
    },
    { path: '*', component: NotFound, meta : {isAuthRequire: false, title:'404'} }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js